import React, { Component } from "react";
import paycard from "../../../../assets/img/payment/cardpay.svg";
import { connect } from "react-redux";
import { OtherPayment } from "../../../../redux/actions/Cart.Action";
class Card extends Component {
  render() {
    return (
      <div className="  row">
        <div className="col">
          <img src={paycard} alt="paycar" width="300" />
        </div>
        <div className="col align-content-center">
          <h4>TID</h4>
          <input
            className="form-control"
            placeholder="TID From Swipe"
            onChange={(e) =>
              this.props.OtherPayment(
                "card",
                this.props.CurrentCart.total,
                e.target.value
              )
            }
          />
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    CurrentCart: state.Cart.CurrentCart,
  }),
  { OtherPayment }
)(Card);
